export default __webpack_public_path__ + "static/media/jclogo.3a86473b.svg";